import SuiteNavigationBar from './SuiteNavigationBar';

export default SuiteNavigationBar;
